// extracted by mini-css-extract-plugin
export var tab = "styles-module--tab--6c8ef";
export var tabHeading = "styles-module--tabHeading--f2f07";
export var toggle = "styles-module--toggle--2d208";